/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {Document, Page, Image, View} from '@react-pdf/renderer';
import {styles} from './styles';
import {AssurranceRetraite} from './assurranceRetraiteWeb';

export const CpCgRetraite = (props: any) => {
  const {detailContrat} = props;
  return (
    <Document>
      {
        //CP retraite
      }
      <Page size="A4" style={styles.page}>
        <Image src={require('../../../../ressources/images/retraite_web.png')} style={styles.image} />
        <View style={styles.containerBlock}>
          <AssurranceRetraite detailContrat={detailContrat} />
        </View>
      </Page>
      {
        //cg retraite
      }
      <Page size="A4">
        <Image src={require('../../../../ressources/cgCp/Retraite/cg/CG_RETRAITE-1.png')} style={styles.image} />
      </Page>
      <Page size="A4">
        <Image src={require('../../../../ressources/cgCp/Retraite/cg/CG_RETRAITE-2.png')} style={styles.image} />
      </Page>
      <Page size="A4">
        <Image src={require('../../../../ressources/cgCp/Retraite/cg/CG_RETRAITE-3.png')} style={styles.image} />
      </Page>
      <Page size="A4">
        <Image src={require('../../../../ressources/cgCp/Retraite/cg/CG_RETRAITE-4.png')} style={styles.image} />
      </Page>
    </Document>
  );
};
